import { render, staticRenderFns } from "./app-subheader.vue?vue&type=template&id=0dda4e18&"
import script from "./app-subheader.vue?vue&type=script&lang=ts&"
export * from "./app-subheader.vue?vue&type=script&lang=ts&"
import style0 from "./app-subheader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports